import {org} from "boislocal-platform-platform-api-api-js-export";

export type ExternalFile = org.boislocal.platform.s2.commons.domain.model.ExternalFileDTO
export type CreditedFile = org.boislocal.platform.s2.commons.domain.model.CreditedFileDTO
export type CreditedFileCommand = org.boislocal.platform.s2.commons.domain.model.CreditedFileCommandDTO
export type FileName = string
export const METADATA_CREDIT_KEY = org.boislocal.platform.s2.commons.domain.model.METADATA_CREDIT_KEY
